import React from "react"
import { Outlet, type RouteObject } from "react-router-dom"

import { PermissionGate } from "../../../../components/PermissionGate/PermissionGate.tsx"
import { RoutesPaths } from "../../../../constants/routes.ts"
import ContractAddPage from "../../../Contracts/ContractAddPage/ContractAddPage.tsx"
import ContractEditPage from "../../../Contracts/ContractEditPage/ContractEditPage.tsx"
import ContractViewPage from "../../../Contracts/ContractViewPage/ContractViewPage.tsx"
import { ContractsPage } from "../../../Contracts/ContractsPage/ContractsPage.tsx"
import { ContractsLayout } from "../../../Contracts/components/ContractsLayout.tsx"

export const contractRoutes: RouteObject[] = [
  {
    element: (
      <PermissionGate paths={["leads.features.lead_contract_approval"]}>
        <Outlet />
      </PermissionGate>
    ),
    children: [
      {
        path: `${RoutesPaths.contract.add}`,
        element: <ContractAddPage />
      },
      {
        path: `${RoutesPaths.contract.edit(":id")}`,
        element: <ContractEditPage />
      },
      {
        path: RoutesPaths.contract.list,
        element: <ContractsLayout />,
        children: [
          { index: true, element: <ContractsPage /> },
          { path: ":id", element: <ContractViewPage /> }
        ]
      }
    ]
  }
]
